import { ChannelTitle, LessonPlan, getFolderFromExplorer } from '@lessonup/typescript-core/domain';
import { channelRoute } from '@lessonup/typescript-core/services';
import React from 'react';
import Breadcrumbs from '../../../components/breadcrumbs/Breadcrumbs';
import LessonPlanPage from '../../lessonPlan/LessonPlanPage';
import { ChannelSubPageProps } from '../ChannelPageTypes';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- auto-generated TECH-258
const ChannelPlanPage: React.FC<ChannelSubPageProps> = ({ activeTab, changeTab, details }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- auto-generated TECH-258
  const { selectionId, subSelectionId, channelPage } = activeTab;
  const { publicFolder } = details;

  if (!selectionId) {
    return null;
  }

  const info = publicFolder && getFolderFromExplorer(publicFolder);

  const backNavigation = (LessonPlan: LessonPlan) => {
    if (!info || !info.parents) return;
    return (
      <Breadcrumbs
        breadcrumbs={info.parents}
        rootFolderName={ChannelTitle.localizeTitle(details.channel.title)}
        getUrl={(folderId) =>
          channelRoute({
            channelSlug: details.channel.name,
            channelPage: 'series',
            selectionId: folderId || undefined,
          })
        }
        currentFolderName={LessonPlan.name}
      />
    );
  };

  return <LessonPlanPage planId={selectionId} backNavigation={backNavigation} inChannelContext={true} />;
};

export default ChannelPlanPage;
